import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

const moduleSelector = '.category-section-3';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            <a href="${item.link}" class="cat-box-wrapper ${item.categoryName || ''}">
              <div class="image-wrapper">
                <img src="${item.background}" alt="">
              </div>
              <div class="content-wrapper">
                <h3 class="title">${item.categoryName || ''}</h3>
                <p class="details">${item.details || ''}</p>
                ${item.buttonText ? `<button class="btn-custom primary">${item.buttonText}</button>` : ''}
              </div>
            </a>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

(() => {
  document.querySelectorAll('.category-section-3 .splide').forEach((item) => {
    const slider = new Splide(item, {
      type: 'slide',
      perPage: 6,
      perMove: 1,
      gap: 20,
      drag: 'free',
      pagination: true,
      arrows: false,
      autoplay: false,
      breakpoints: {
        1366: {
          perPage: 4,
        },
        991: {
          perPage: 3,
        },
        768: {
          perPage: 2,
        },
        481: {
          perPage: 1,
        },
      },
    });
    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
